/* This file was generated by running "node scripts/generateTranslations.js". */
/* Created: 2025-04-29 10:47:51 */

const Keys = {
  adult: 'adult',
  adult_plural: 'adult_plural',
  child: 'child',
  child_plural: 'child_plural',
  infant: 'infant',
  infant_plural: 'infant_plural',
  button: 'button',
  traveler: 'traveler',
  traveler_plural: 'traveler_plural',
  guest: 'guest',
  guest_plural: 'guest_plural',
  room: 'room',
  room_plural: 'room_plural',
  addRoom: 'addRoom',
  travellerAgeInfo: 'travellerAgeInfo',
  age: 'age',
  ageCapitalized: 'ageCapitalized',
  validationErrorMessage: 'validationErrorMessage',
  childAgeErrorMessage: 'childAgeErrorMessage',
  childAgeRange: 'childAgeRange',
  infantAgeRange: 'infantAgeRange',
  adultAgeRange: 'adultAgeRange',
  pleaseSelect: 'pleaseSelect',
  updateSearch: 'updateSearch',
  occupancyErrorMessage: 'occupancyErrorMessage'
}; export default Keys;